<!-- This page is only accessible via an URL -->
@if (accountMarketplace() && accountMarketplace()!.accountType !== "SELLER" && !isReadOnly()) {
  <div *transloco="let t">
    <div class="flex items-center justify-between">
      <a iButton [routerLink]="catalogPage" variant="ghost" class="w-full">
        <IIcon name="arrowLeft" />
        {{ t("catalog-upload.back_to_catalog") }}
      </a>
    </div>
    <div class="mt-4">
      <div class="add-box">
        <textarea
          #asins
          placeholder="{{ t('catalog-upload.list_of_asin_input') }}"
          aria-label="Simple textarea"
        ></textarea>

        <button
          iButton
          class="mt-2 ml-2"
          [iTooltip]="t('catalog-upload.add_asins_to_catalog_tooltip')"
          size="md"
          (click)="addAsinToCatalog(asins.value); asins.value = ''"
        >
          {{ t("common.add") }}
        </button>

        <div class="list-errors mt-2">
          @if (errors && errors.length > 0) {
            <ul class="list-group">
              <li class="list-group-item list-group-item list-group-item-warning flex justify-between">
                <span>{{ t("catalog-upload.asins_ignored") }}</span>

                <button
                  iButton
                  [iTooltip]="t('catalog-upload.close_error_table')"
                  variant="secondary"
                  size="icon-sm"
                  (click)="errors = []"
                >
                  <IIcon name="close" />
                </button>
              </li>
              @for (error of errors; track error) {
                <li class="list-group-item list-group-item-secondary py-0">
                  {{ error }}
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
  </div>
}
